// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1-HH8","title":"AfterFrontImage_title__2tss9"};